import { render, staticRenderFns } from "./BuySpyderCreditsModal.vue?vue&type=template&id=6a8f2b7e&scoped=true"
import script from "./BuySpyderCreditsModal.vue?vue&type=script&lang=js"
export * from "./BuySpyderCreditsModal.vue?vue&type=script&lang=js"
import style0 from "./BuySpyderCreditsModal.vue?vue&type=style&index=0&id=6a8f2b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8f2b7e",
  null
  
)

export default component.exports